module.exports = __webpack_public_path__ + "img/banner.aeb50756.png";